// Registra o service worker (public/sw.js) logo na abertura para que os
// arquivos de /assets/ com hash sejam servidos do cache local nas próximas
// aberturas — ver o comentário no topo do sw.js (queixa 2026-10-05: app
// Android rebaixando ~500 KB de JS a cada abertura numa rede lenta).
//
// Na primeira abertura o SW ainda não controla a página, então os arquivos
// já baixados não passam por ele. Depois que a tela carregou, copiamos para
// o cache o que esta página usou (lista do Performance API) — vem do cache
// HTTP quando existe; com a rede ocupada só no boot, espera um pouco antes.

const ASSET_CACHE = "gd-assets-v1"; // mesmos nomes do sw.js
// Limite de itens dos outros caches do sw.js (fotos). O dos módulos do
// Google ("gd-gmaps-v1") saiu em 2026-10-21 — ver sw.js.
const OTHER_CACHE_LIMITS: Record<string, number> = { "gd-media-v1": 300 };
const HASHED_ASSET = /^\/assets\/[^/]+-[A-Za-z0-9_-]{8}\.[a-z0-9]+$/;
// Cada deploy troca alguns hashes; sem limite o cache só cresceria.
const MAX_ENTRIES = 600;
const KEEP_ENTRIES = 400;
const FILL_DELAY_MS = 8_000;

async function fillFromThisPage(): Promise<void> {
  const cache = await caches.open(ASSET_CACHE);
  const urls = new Set<string>();
  for (const entry of performance.getEntriesByType("resource")) {
    const url = new URL(entry.name);
    if (url.origin === location.origin && HASHED_ASSET.test(url.pathname)) {
      urls.add(url.origin + url.pathname);
    }
  }
  for (const url of urls) {
    if (await cache.match(url)) continue;
    try {
      const res = await fetch(url);
      if (res.ok) await cache.put(url, res);
    } catch {
      // sem rede agora — o SW guarda na próxima vez que o arquivo for pedido
    }
  }

  await prune(cache, MAX_ENTRIES, KEEP_ENTRIES);
  for (const [name, limit] of Object.entries(OTHER_CACHE_LIMITS)) {
    await prune(await caches.open(name), limit, Math.floor(limit * 0.7));
  }
}

// keys() vem em ordem de inserção: apaga os mais antigos.
async function prune(cache: Cache, max: number, keep: number): Promise<void> {
  const keys = await cache.keys();
  if (keys.length > max) {
    await Promise.all(keys.slice(0, keys.length - keep).map((k) => cache.delete(k)));
  }
}

export function registerAssetCache(): void {
  if (typeof window === "undefined" || !("serviceWorker" in navigator) || !("caches" in window)) {
    return;
  }
  // iOS (WKWebView do app) não permite SW fora de app-bound domains — a
  // falha aqui só significa "sem cache extra", nada quebra.
  navigator.serviceWorker
    .register("/sw.js")
    .then(() => navigator.serviceWorker.ready)
    .then(() => {
      window.setTimeout(() => {
        void fillFromThisPage().catch(() => {});
      }, FILL_DELAY_MS);
    })
    .catch(() => {});
}
